import React from 'react';
import { X, Star, MapPin, Award } from 'lucide-react';
import './EmptyAreaPopup.css';

function EmptyAreaPopup({ onDismiss, onAddRestroom }) {
  return (
    <div className="empty-area-popup-overlay">
      <div className="empty-area-popup">
        {/* Header */}
        <div className="empty-area-popup-header">
          <h2>
            Nobody has mapped<br />
            <span className="highlight">this area yet.</span>
          </h2>
          <button 
            className="empty-area-popup-close"
            onClick={onDismiss}
            aria-label="Close popup"
          >
            <X size={24} />
          </button>
        </div>

        {/* Body */}
        <div className="empty-area-popup-body">
          <div className="empty-area-popup-icon">
            <img src="/app-icon.png" alt="The Crapper Mapper" />
          </div>
          <p className="empty-area-popup-text">
            Be the first to put your town on the map and help every traveler who comes through.
          </p>
          
          <ul className="empty-area-popup-features">
            <li>
              <Star size={20} className="feature-icon" />
              <div className="feature-content">
                <strong>Be a Local Hero</strong>
                <span>Be the <span className="highlight">first</span> contributor in your area.</span>
              </div>
            </li>
            <li>
              <MapPin size={20} className="feature-icon" />
              <div className="feature-content">
                <strong>Help the Community</strong>
                <span>Your review helps others find clean restrooms.</span>
              </div>
            </li>
            <li>
              <Award size={20} className="feature-icon" />
              <div className="feature-content">
                <strong>Earn Recognition</strong>
                <span>Unlock the Pioneer badge and climb the leaderboard.</span>
              </div>
            </li>
          </ul>
        </div>

        {/* Footer */}
        <div className="empty-area-popup-footer">
          <button 
            className="empty-area-popup-btn primary"
            onClick={onAddRestroom}
          >
            Add the First Restroom
          </button>
          <button 
            className="empty-area-popup-btn secondary"
            onClick={onDismiss}
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
}

export default EmptyAreaPopup;
